import { EventsModalService } from "../../features/events/services/modal.service";
import { ClassData } from "../dtos/classes.type";
import { DEFAULT_CATEGORY } from "../services/default-category.service";
import { getDayByProperty, getValueByAgeCode } from "../utils/classes.util";
import {
  LOGIN_BUTTON_LINK,
  RYB_CLASSES_DATA,
  URL_PARAMETERS,
} from "../utils/const.util";
import {
  additionalUrlParameters,
  getPreloadClassId,
  getUrlParameterValue,
  parseRegistrationLink,
} from "../utils/url.util";

export function openModal(
  cardData: ClassData,
  id: "invite-only" | "base" | "form" | null = null
) {
  const modal = id ? `.ryb-connect-overlay#${id}` : ".ryb-connect-overlay";
  $(".ryb-connect-modal .modal-title").html(cardData.category2); // it's predefined as category2 - keep it like that
  $(".ryb-connect-modal .modal-address").html(cardData.location);
  $(".ryb-connect-modal .modal-price").html(cardData.tuition.fee.toString());
  $(".ryb-connect-modal .modal-min-age").html(
    getValueByAgeCode(cardData.min_age)
  );
  $(".ryb-connect-modal .modal-max-age").html(
    getValueByAgeCode(cardData.max_age)
  );
  $(".ryb-connect-modal .modal-gender").html(cardData.gender);
  $(".ryb-connect-modal .modal-meeting-day").html(
    getDayByProperty(cardData.meeting_days)
  );
  $(".ryb-connect-modal .modal-start-time").html(cardData.start_time);
  $(".ryb-connect-modal .modal-end-time").html(cardData.end_time);
  $(modal).addClass("show");
  setModalButtonsFunctionality(cardData);

  if (id === "invite-only") {
    $(".ryb-connect-modal").attr("data-category-two", cardData.category2);
    $(".ryb-connect-modal").attr("data-class-name", cardData.name);
    const shortcode = RYB_CLASSES_DATA.classes.find(
      (category) => category.display_name === cardData[DEFAULT_CATEGORY]
    )?.invite_only_funnel_shortcode;
    if (shortcode) {
      const match = shortcode.match(/id\s*=\s*"(\d+)"/);
      const isResultContainer = $("#ryb-openings-result.show");
      console.log("match : ", match);
      console.log("isResultContainer : ", isResultContainer);
      if (match && isResultContainer) {
        moveWizardToModal(match?.[1] || "");
      }
    }
  }

  $(modal).on("click", function () {
    closeModal();
  });

  $(".ryb-connect-modal .close-modal").on("click", function () {
    closeModal();
  });

  $(`${modal} *`).on("click", function (event) {
    event.stopPropagation();
  });
}

export function setModalButtonsFunctionality(cardData: ClassData) {
  const triggerContactModal =
    getUrlParameterValue(URL_PARAMETERS.CONTACT) === "false";
  const fallbackUrl =
    RYB_CLASSES_DATA.classes?.find(
      (category) => category.name === cardData[DEFAULT_CATEGORY]
    )?.fallback_url || "";

  const classId = getPreloadClassId(cardData.online_reg_link, "preLoadClassID");
  const orgId = getPreloadClassId(cardData.online_reg_link, "id");
  $(".already-registerd-button").attr("value", classId);
  $(".already-registerd-button").attr("oid", orgId);
  $(".already-registered-button")
    .data("classId", classId)
    .data("orgId", orgId)
    .attr("data-class-id", classId)
    .attr("data-org-id", orgId);

  $(".already-registered-button").on("click", function () {
    const clickedClassId = $(this).data("classId");
    const clickedOrgId = $(this).data("orgId");
    if (triggerContactModal) {
      window.open(additionalUrlParameters(fallbackUrl || ""), "_blank");
    } else {
      window.open(
        `${LOGIN_BUTTON_LINK}?orgId=${clickedOrgId}&regcid=${clickedClassId}`,
        "_blank"
      );
    }
  });

  $("#form.ryb-connect-overlay form .form-submit")
    .data(
      "dataUrl",
      parseRegistrationLink(
        cardData.online_reg_link || fallbackUrl,
        cardData.tuition.fee.toString(),
        cardData.category1,
        cardData.category2
      )
    )
    .attr(
      "data-url",
      parseRegistrationLink(
        cardData.online_reg_link || fallbackUrl,
        cardData.tuition.fee.toString(),
        cardData.category1,
        cardData.category2
      )
    );

  $("#form.ryb-connect-overlay form .form-submit").on(
    "click",
    function (event) {
      event.preventDefault();

      const submitButton = $(this);
      submitButton
        .prop("disabled", true)
        .addClass("loading")
        .text("Processing...");

      EventsModalService.handleSubmit(
        cardData,
        triggerContactModal
          ? additionalUrlParameters(
              fallbackUrl,
              cardData.tuition.fee.toString(),
              cardData.category1,
              cardData.category2
            )
          : parseRegistrationLink(
              cardData.online_reg_link,
              cardData.tuition.fee.toString(),
              cardData.category1,
              cardData.category2
            ),
        "#form"
      )
        ?.then(() => {
          if (triggerContactModal) {
            window.open(
              additionalUrlParameters(
                fallbackUrl || "",
                cardData.tuition.fee.toString(),
                cardData.category1,
                cardData.category2
              ),
              "_blank"
            );
          } else {
            window.open(
              parseRegistrationLink(
                cardData.online_reg_link,
                cardData.tuition.fee.toString(),
                cardData.category1,
                cardData.category2
              ),
              "_blank"
            );
          }

          submitButton
            .prop("disabled", false)
            .removeClass("loading")
            .text("Continue");

          $(".ryb-connect-overlay form")?.trigger("reset");

          closeModal();
        })
        .catch((error) => {
          console.error(error);
          submitButton
            .prop("disabled", false)
            .removeClass("loading")
            .text("Continue");
        });

      submitButton
        .prop("disabled", false)
        .removeClass("loading")
        .text("Continue");
    }
  );
}

export function closeModal() {
  $(".ryb-connect-overlay").removeClass("show");
  $(".ryb-connect-modal .form").empty();
  const url = new URL(window.location.href);
  url.searchParams.delete("step_id");

  window.history.replaceState({}, "", url.toString());

  const styleTags = document.head.querySelectorAll("style");
  styleTags.forEach((style) => {
    if (
      style.innerText.includes(
        "/*! tailwindcss v4.1.11 | MIT License | https://tailwindcss.com */"
      )
    ) {
      style.remove();
    }
  });
}

function moveWizardToModal(resourceId: string) {
  console.log("hello from moveWizardToModal");
  const modalFormContainer = $("#invite-only .ryb-connect-modal .form");
  const storedData = (window as any).theShortcodeApp[resourceId];
  modalFormContainer.empty();

  if (storedData) {
    modalFormContainer.html(storedData.html);
    const wizardElement = modalFormContainer.find("#ryb-wizard");
    if (wizardElement.length) {
      wizardElement.attr("data-resource-id", resourceId);

      if (typeof (window as any).renderWizardApp === "function") {
        (window as any).renderWizardApp();
      }
    } else {
      console.error("#ryb-wizard element not found in the preloaded HTML.");
    }
  } else {
    console.error(`No preloaded data found for resourceId="${resourceId}"`);
  }
}
